import DashboardSectionContainer from './dashboard-section-container'

export default DashboardSectionContainer
